import {createSelector, includes} from 'helpers';
import {settings} from 'store/settings';

const externalCalendars = createSelector(
  settings,
  settings => settings.externalCalendars,
);

export const externalCalendarsFilter = createSelector(
  [ externalCalendars ],
  ( externalCalendars ) => ({ importedEvent, googleEventId, iOSEventId }) => {
    if (importedEvent && googleEventId && !includes(externalCalendars, 'google')) {
      return false;
    }
    if (importedEvent && iOSEventId && !includes(externalCalendars, 'icloud')) {
      return false;
    }
    return true;
  }
);
